(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDialogController', CustomMaterialTypeAttributeDialogController);

    CustomMaterialTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.custommaterialtypeattributevalues = CustomMaterialTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues != null && vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.length != 0) {
			vm.items = vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customMaterialTypeAttribute.id !== null) {
            	
            	 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomMaterialTypeAttribute.update(vm.customMaterialTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomMaterialTypeAttribute.save(vm.customMaterialTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customMaterialTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-material-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
